import React,{Component} from "react";
import {getBranch,getRegion,getDepartment,main_url,getFirstDayOfMonth} from '../../utils/CommonFunction';
import DatePicker from 'react-datetime';
import moment from "moment";
import Select from "react-select";
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'jspdf-autotable';
import { getHeaders } from "../../utils/apiHelper";
const $ = require('jquery');
const jzip = require('jzip');
window.JSZip = jzip;
$.DataTable = require('datatables.net-bs4');
$.DataTable = require('datatables.net-responsive-bs4');
$.DataTable = require('datatables.net');
require('datatables.net-buttons/js/dataTables.buttons.min');
require('datatables.net-buttons/js/buttons.html5.min');


class ConfirmationReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch:[],
            region:[],
            confirmation:[],
            department:[],
            confirmation_type:null,
            branchId:null,
            regionId:null,
            departmentId:null,
            from_date:moment(),
            dataSource:[],
            to_date:moment(),
            recommendation:[{label:'Confirmation',value:0},{label:'Extensions',value:1},{label:'Terminations',value:2}]
        }
    }
    
    async componentDidMount (){
        this.$el = $(this.el);
        this.setState(
          {
            dataSource: this.props.data,
    
          },
          () => {
            this._setTableData(this.state.dataSource);
          }
        );
    

        let branch = await getBranch();
        branch.unshift({ label: 'All', value: 0 });
        let department = await getDepartment();
       department.unshift({ label: 'All', value: 0 });
        let region = await getRegion();
        region.unshift({state_name: 'ALL', state_id: 0});
        // await getConfirmationType;
        this.setState({
            branch: branch,
            department: department,
            region: region.map(v => ({ ...v, label: v.state_name, value: v.state_id })),
            // confirmation:comfirmation
           
        })
    }
    handleSelectedBranch = async (event) => {
        this.setState({
           branchId : event
        })
    }
    
    handleSelectedDepartment = async (event) => {
        this.setState({
           departmentId : event
        })
    }
    handleSelectedRegion = async (event) => {
        this.setState({
           regionId : event
        })
    }
     
    handleSelectedConfirmtype = async (event) => {
        this.setState({
           confirmation_type : event
        })
    }
    handleSelectedFromdate = async (event) => {
        this.setState({
           from_date : event
        })
    }
     handleSelectedTodate = async (event) => {
        this.setState({
           to_date : event
        })
    }
    handleSearchData = () => {
        fetch(`${main_url}report/confirmationReport/${this.state.regionId == undefined ? 0 : this.state.regionId.state_id}/${this.state.branchId == undefined ? 0 : this.state.branchId.value}/${this.state.departmentId == undefined ? 0 : this.state.departmentId.value}/${this.state.confirmation_type == undefined ? 0 : this.state.confirmation_type.label}/${moment(this.state.from_date).format('YYYY-MM-DD')}/${moment(this.state.to_date).format('YYYY-MM-DD')}`, {
          headers: getHeaders(),
        })
          .then(res => { if (res.ok) return res.json() })
          .then(list => {
            this._setTableData(list);
          })
      }

    _setTableData = (data) => {
        var table;
        var l = [];
        if (data) { 
        for (var i = 0; i < data.length; i++) {
            let result = data[i];
            let obj = [];
                obj = {
                no: i + 1,
                employee_id:data[i].employment_id ? data[i].employment_id :'-',
                employee_name: data[i].fullname ? data[i].fullname :'-',
                branch: data[i].branch_name ? data[i].branch_name :'-', 
                designation:data[i].designations ? data[i].designations :'-',
                level:data[i].career_level ? data[i].career_level : '-',
                department:data[i].deptname ? data[i].deptname :'-',
                region:data[i].region_name ? data[i].region_name :'-',
                effective_date:data[i].effective_date ? moment(data[i].effective_date).format('YYYY-MM-DD') :'-',
                pa_score:data[i].performance_score ? data[i].performance_score :"-",
                target_achievement:data[i].target_achievement ? data[i].target_achievement : '-',
                overall_performance:data[i].comment_overall_performance ? data[i].comment_overall_performance :'-',
                confirmation_type:data[i].confirm_or_not ? data[i].confirm_or_not : '-',
                old_career_sub_level:data[i].old_career_sub_level ? data[i].old_career_sub_level : data[i].new_career_sub_level,
                new_career_sub_level:data[i].new_career_sub_level ? data[i].new_career_sub_level : '-',
                increase_amount:data[i].increase_amount ? data[i].increase_amount : '0'
            }    
            l.push(obj)

        }}
        if ($.fn.dataTable.isDataTable('#dataTables-table')) {
            table = $('#dataTables-table').dataTable();
            table.fnClearTable();
            table.fnDestroy();
            $('#dataTables-table').empty();
        }
        var column = [
            { title: "  No", data: "no" },
            { title: "Employee Id", data: "employee_id" },
            { title: " Name", data: "employee_name" },
            { title: "Designation", data: "designation" },
            { title: "Level", data: "level" },
            { title: "Department", data: "department" },
            { title: "Branch", data: "branch" },
            { title: "Region", data: "region" },
            { title: "Effective Date", data: "effective_date" },
            { title: "PA Score", data: "pa_score" },
            { title: "Target Achievement", data: "target_achievement" },
            { title: "Comment for overall Performance", data: "overall_performance" },
            { title: "Confirmation Type", data: "confirmation_type" },
            {
              title:"Old Career Sub Level",data:"old_career_sub_level"
            },
            {
              title:"New Career Sub Level",data:"new_career_sub_level"
            },
            {
              title:"Increase Amount",data:"increase_amount"
            }
        ]
        table = $("#dataTables-table").DataTable({

            autofill: true,
            bLengthChange: false,
            bInfo: false,
            responsive: true,
            pageLength: 50,
            paging: true,
        //     // buttons: true,
            dom: 'Bfrtip',
        //     // buttons: [
        //     //     'copy', 'csv', 'excel', 'pdf'
        //     // ],
            buttons: [
        //         // 'copy',
        //         // {
        //         //         extend: 'csvHtml5',
        //         //         title: 'Confirmation Report',
        //         // },
        {
            extend: 'excelHtml5',
            title: 'Confirmation Report',
        },
        //         // {
        //         //     extend: 'pdfHtml5',
        //         //     title: 'Child Benefit',
        //         // }
            ],
            data: l,
            columns: column
        });

    }
        render(){ console.log(this.state.region);
          
        return (
            <div>
            <div className="row  white-bg dashboard-header">
           
              <div className='flex-row' style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', margin: '10px 10px 10px 0px' }}>
           <div style={{width:'150px',marginRight:10}}>
              <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.from_date}
                  onChange={this.handleSelectedFromdate}
                  timeFormat={false}
                 
                />
                </div>
                <div style={{width:'150px'}}>
              <DatePicker
                 dateFormat="DD/MM/YYYY"
                 value={this.state.to_date}
                 onChange={this.handleSelectedTodate}
                 timeFormat={false}
                 style={{width:150}}
                /> </div>
              <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginLeft:10
                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Region"
              options={this.state.region}
              onChange={this.handleSelectedRegion}
              value={this.state.regionId}
              className='react-select-container'
              classNamePrefix="react-select"
            /> 
            <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginLeft:10

                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Branch"
              options={this.state.branch}
              onChange={this.handleSelectedBranch}
              value={this.state.branchId}
              className='react-select-container'
              classNamePrefix="react-select"
            />
            <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginLeft:10

                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Department"
              options={this.state.department}
              onChange={this.handleSelectedDepartment}
              value={this.state.departmentId}
              className='react-select-container'
              classNamePrefix="react-select"
            />
             <Select
              styles={{
                container: base => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginLeft:10

                }),
                control: base => ({
                  ...base,
                  minHeight: '18px'
                }),

              }}
              placeholder="Confirmation Type"
              options={this.state.recommendation}
              onChange={this.handleSelectedConfirmtype}
              value={this.state.confirmation_type}
              className='react-select-container'
              classNamePrefix="react-select"
            />
            <button className='btn btn-primary text-center' style={{ marginLeft: 10, height: 30, padding: '0px 5px 0px 5px' }} onClick={() => this.handleSearchData()}>Search</button>
            </div>
           </div>
            <table width="99%"
                    className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
                    id="dataTables-table"
                />
           </div>
        )
    }
}
    export default ConfirmationReport;